import { useQueryClient, useMutation } from '@tanstack/react-query';
import { removeAllUpcomingSessionsPrivate } from '../utils/Network';

type RemoveAllUpcomingSessionsByGroupRequest = {
  startDate: string;
  groupId: number;
  userToken: string;
};

const _removeAllUpcomingSessionsByGroup = async (data: RemoveAllUpcomingSessionsByGroupRequest) => {
  return removeAllUpcomingSessionsPrivate(data.startDate, data.groupId, data.userToken);
};

const useRemoveAllUpcomingSessionsByGroup = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: _removeAllUpcomingSessionsByGroup,

    onSuccess: (data) => {
      console.log('Sessions removed successfully:', data);
      // Invalidate sessions queries to refresh the calendar
      queryClient.invalidateQueries({
        queryKey: ['sessions'],
      });
      // Invalidate privateGroupHasSessions to update the "has sessions" state
      queryClient.invalidateQueries({
        queryKey: ['privateGroupHasSessions'],
      });
      // Invalidate privateGroups to refresh the group data
      queryClient.invalidateQueries({
        queryKey: ['privateGroups'],
      });
    },
    onError: (error) => {
      console.error('Error removing sessions:', error);
    },
  });
};

export default useRemoveAllUpcomingSessionsByGroup;
